"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_CREDIT_CARD_EMAIL = exports.REMOVE_PAYMENT_METHOD = exports.SET_CIMA_NEW_CARD_DEFAULT_PAYMENT_METHOD = exports.PERSIST_CIMA_PAYMENT_METHOD_ORIGINAL_GATEWAY = exports.UPDATE_PAYMENT_INFORMATION_BY_LEGALENTITY = exports.UPDATE_PAYMENT_INFORMATION = void 0;
exports.UPDATE_PAYMENT_INFORMATION = `
	mutation updateZuoraAccountPaymentInformation($paymentInfo: ZuoraAccountPaymentInfo){
		updateZuoraAccountPaymentInformation(paymentInfo: $paymentInfo) {
			Success Errors {
				Message Code
			}
		}
	}
`;
exports.UPDATE_PAYMENT_INFORMATION_BY_LEGALENTITY = `
	mutation updateZuoraAccountPaymentInformationByLegalEntity($zuoraId: String,$paymentInfo: ZuoraAccountPaymentInfoV2, $legalEntity: String, $cardType: String, $currency: String, $cimaGatewayAttempt: String ) {
		updateZuoraAccountPaymentInformationByLegalEntity(zuoraId: $zuoraId,paymentInfo: $paymentInfo, legalEntity: $legalEntity, cardType: $cardType, currency: $currency, cimaGatewayAttempt: $cimaGatewayAttempt) {
				success
				errors {
						message
						code
						reasonCode
				}
		}
	}
`;
exports.PERSIST_CIMA_PAYMENT_METHOD_ORIGINAL_GATEWAY = `
	mutation persistCimaPaymentMethodOriginalGateway($paymentMethodId: String!, $gatewayAttempt: String!, $zuoraAccountId: String) {
		persistCimaPaymentMethodOriginalGateway(paymentMethodId: $paymentMethodId, gatewayAttempt: $gatewayAttempt, zuoraAccountId: $zuoraAccountId) {
			success
			paymentMethodId
			originalPaymentGateway
			alreadyPersisted
			code
			message
		}
	}
`;
// Makes a newly created CIMA card the default by its exact ID; fails closed (no gateway fallback)
exports.SET_CIMA_NEW_CARD_DEFAULT_PAYMENT_METHOD = `
	mutation setCimaNewCardDefaultPaymentMethod($paymentMethodId: String!, $gatewayAttempt: String!, $zuoraAccountId: String) {
		setCimaNewCardDefaultPaymentMethod(paymentMethodId: $paymentMethodId, gatewayAttempt: $gatewayAttempt, zuoraAccountId: $zuoraAccountId) {
			success
			paymentMethodId
			paymentGatewayUpdated
			code
			message
		}
	}
`;
exports.REMOVE_PAYMENT_METHOD = `
	mutation deletePaymentMethod($paymentMethodId: String!, $isDefault: Boolean, $cardNumberLastFour: String, $hasActiveSubscriptions: Boolean, $hasActiveStandingOrders: Boolean, $hasUserPhysicalAwaitingOrders:Boolean, $legalEntity: String, $fromSetDefaultPaymentAction:Boolean){
		deletePaymentMethod(paymentMethodId: $paymentMethodId, isDefault: $isDefault, cardNumberLastFour: $cardNumberLastFour, hasActiveSubscriptions: $hasActiveSubscriptions, hasActiveStandingOrders: $hasActiveStandingOrders, hasUserPhysicalAwaitingOrders: $hasUserPhysicalAwaitingOrders, legalEntity: $legalEntity, fromSetDefaultPaymentAction: $fromSetDefaultPaymentAction) {
			success reasons {
				message
				code
			}
		}
	}
`;
exports.SEND_CREDIT_CARD_EMAIL = `
	mutation sendCreditCardMail($definitionKey: String!, $cardNumberLastFour: String!){
		sendCreditCardMail(definitionKey: $definitionKey, cardNumberLastFour: $cardNumberLastFour) { success }
	}
`;
//# sourceMappingURL=credit-card-queries.js.map